export const ANONYMOUS_ID_KEY = 'anonymousId';
export const ANONYMOUS_ID_NAMESPACE = `@vw/${ANONYMOUS_ID_KEY}`;
